import cn from 'classnames';
import { SIconCheckbox } from '@widgets/coaches/filter/styles';
import { SecondCheckedCheckboxIcon, SecondUnCheckedCheckboxIcon } from '@shared/assets';
import st from './styles.module.scss';

interface Props {
  items: any[];
  selectedItems: number[];
  onItemClick: (id: number) => void;
}

/**
 * Список чекбоксов
 * @param {any[]} items - массив любых объект
 * Для корректной работы должны быть поля
 * @param {number} items[].id
 * @param {string} items[].title
 */

export const CheckboxList: React.FC<Props> = ({ items, selectedItems, onItemClick }) => {
  const isTagChecked = (id: number): boolean => {
    return selectedItems.includes(id);
  };
  return (
    <ul className={st.list}>
      {items?.map((item) => {
        const isSelected = isTagChecked(item.id);
        return (
          <li className={cn(st.item, isSelected && st.selected)} key={item.id}>
            <SIconCheckbox
              className={st.section}
              labelClassName={st.checkboxLabel}
              checked={isSelected}
              checkedIcon={<SecondCheckedCheckboxIcon />}
              unCheckedIcon={<SecondUnCheckedCheckboxIcon />}
              label={item.title}
              onClick={() => onItemClick(item.id)}
            />
          </li>
        );
      })}
    </ul>
  );
};
